var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('AppBarPublic'),_c('v-main',{staticClass:"mb-10"},[_vm._t("default")],2),(false)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }